import React from 'react';
import { InputFieldsWrapper } from '.././PTPlusStyled'
import TickSuccessImage from "web/assets/images/tick-success-sign.gif";

function CompletionPage(pageProps) {
    let pageFieldValues = pageProps.formikProps.values

    return (
        <InputFieldsWrapper>
            <div className='completion-page'>
                <img src={TickSuccessImage} alt="TickSuccessImage" />
                <h4>The client account has been added successfully.</h4>
                <div style={{ display: 'flex', justifyContent: 'center' }}><h5>{`Password setup instructions has been sent to
                the associated email address ${pageFieldValues?.email}.`}</h5></div>
                <button className='save-button mt-5' onClick={() => pageProps.skipButtonCall()}>Ok</button>
            </div>
        </InputFieldsWrapper>
    )

}

export default CompletionPage